import clsx from 'clsx';
import {useState} from 'react';
import SVG from 'react-inlinesvg';
import appColors from '../../../../_mesomb/utils/appColors.ts';

// const colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B']

export interface HIconProps {
  image?: string;
  text?: string;
  size: number;
  className?: string;
  initialsLength?: 1 | 2;
  fallbackOnError?: boolean;
  imageFit?: 'contain' | 'cover';
  decorative?: boolean;
}

function HIcon({ image, text, size, className, initialsLength = 1, fallbackOnError = false, imageFit, decorative = false }: HIconProps) {
  const [failedImage, setFailedImage] = useState<string>();
  const showImage = image && (!fallbackOnError || failedImage !== image);
  const initials = initialsLength === 2
    ? text?.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(word => Array.from(word)[0]).join('').toLocaleUpperCase()
    : text?.charAt(0).toUpperCase();
  if (!image && !text) {
    return null;
  }
  return (
    <div className={clsx(`symbol symbol-${size}px`, className)} aria-hidden={decorative || undefined}>
      {showImage ? (
        image.startsWith('<svg') ? (
          <SVG src={image} width={size} height={size} onError={fallbackOnError ? () => setFailedImage(image) : undefined} />
        ) : (
          <img key={image} src={image} alt={decorative ? '' : text} style={imageFit ? {objectFit: imageFit} : undefined} decoding='async' onError={fallbackOnError ? () => setFailedImage(image) : undefined} />
        )
      ) : (
        <span
          className='symbol-label text-inverse-primary fw-bold'
          style={{
            fontSize: size / (initialsLength === 2 ? 2.5 : 1.6),
            backgroundColor: appColors[(text?.length ?? 0) % appColors.length],
          }}
        >
          {initials || '•'}
        </span>
      )}
    </div>
  );
}

export default HIcon;
